import { render, staticRenderFns } from "./PrintableDonator.vue?vue&type=template&id=773d4981"
import script from "./PrintableDonator.vue?vue&type=script&lang=js"
export * from "./PrintableDonator.vue?vue&type=script&lang=js"
import style0 from "./PrintableDonator.vue?vue&type=style&index=0&id=773d4981&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports